export default __webpack_public_path__ + "static/media/kitchen3-after3-1440w.df34a7f0.webp";